import React from 'react';

interface IUnlockTimeContext {
  isLocked: boolean | null;
}

export const UnlockTimeContext = React.createContext<IUnlockTimeContext>({
  isLocked: null,
});
